import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allRoleMemberships: [],
  roleMembership: {},
  roleMembershipsByUserID: [],
  roleMembershipsByRoleID: [],
  createdRoleMembership: null,
  updatedRoleMembership: null,
  deletedRoleMembership: null,
  roleMembershipInformationModal: false,
  error: [],
};

const roleMembershipSlice = createSlice({
  name: 'roleMembership',
  initialState,
  reducers: {
    startRoleMembership: (state, action) => {
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    toggleRoleMembership: (state, action) => {
      state.roleMembershipInformationModal = !state.roleMembershipInformationModal;
    },
    setAllRoleMemberships: (state, action) => {
      state.allRoleMemberships = action.payload;
      state.error = [];
    },
    setRoleMembership: (state, action) => {
      state.roleMembership = action.payload;
      state.error = [];
    },
    setRoleMembershipsByUserID: (state, action) => {
      state.roleMembershipsByUserID = action.payload;
      state.error = [];
    },
    setRoleMembershipsByRoleID: (state, action) => {
      state.roleMembershipsByRoleID = action.payload;
      state.error = [];
    },
    setCreatedRoleMembership: (state, action) => {
      state.createdRoleMembership = action.payload;
      state.error = [];
    },
    setUpdatedRoleMembership: (state, action) => {
      state.updatedRoleMembership = action.payload;
      state.error = [];
    },
    setDeletedRoleMembership: (state, action) => {
      state.deletedRoleMembership = action.payload;
      state.error = [];
    },
    setResetRoleMng: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  startRoleMembership,
  toggleRoleMembership,
  setAllRoleMemberships,
  setRoleMembership,
  setRoleMembershipsByUserID,
  setRoleMembershipsByRoleID,
  setCreatedRoleMembership,
  setUpdatedRoleMembership,
  setDeletedRoleMembership,
  setResetRoleMng,
} = roleMembershipSlice.actions;

export default roleMembershipSlice.reducer;
